import { render, staticRenderFns } from "./iconJCB.vue?vue&type=template&id=6b338420"
import script from "./iconJCB.vue?vue&type=script&lang=js"
export * from "./iconJCB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports